import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  const menuItems = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Products', href: '/products' },
    { name: 'Industries', href: '/industries' },
    { name: 'Training', href: '/training' },
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact Us', href: '/contact' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Column 1 - Logo & Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img src="/images/aswartha x logo.png" alt="ASWARTHA Logo" className="w-auto" style={{height: '60px'}} />
            </div>
            <p className="text-gray-300 leading-relaxed">
              Your digital partner in asset lifecycle intelligence, delivering predictive maintenance, 
              lifecycle optimization, and data-driven asset strategies for industrial excellence.
            </p>
          </div>

          {/* Column 2 - Menu Navigation */}
          <div>
            <h4 className="font-semibold mb-6 text-lg">Quick Navigation</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {menuItems.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm text-gray-300 hover:text-[#3BA6EA] transition-colors block py-1"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 3 - Contact Information & Social */}
          <div>
            <h4 className="font-semibold mb-6 text-lg">Get in Touch</h4>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#3BA6EA] mt-1 flex-shrink-0" />
                <span className="text-gray-300">
                  India, Bahrain, Dubai and USA
                </span>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#3BA6EA] mt-1 flex-shrink-0" />
                <div className="text-gray-300">
                  <div className="mb-1">+91-9944574442</div>
                  <div>+91-9391008458</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#3BA6EA] mt-1 flex-shrink-0" />
                <div className="text-gray-300">
                  <div className="mb-1">info@aswartha.com</div>
                  <div>gnraju@aswartha.com</div>
                </div>
              </div>
            </div>

            {/* Social Media */}
           
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8">
          <p className="text-center text-sm text-gray-400">
            © 2024 Aswartha Asset Management Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;